import React from "react";
import "../../css/Tools/Tools.css";

const CollegeList = () => {
  return (
    <div className="tool-container">
      <div className="tool-content">
        <div className="tool-icon-container">
          <svg
            className="tool-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>

        <div className="tool-status">
          <svg
            className="tool-status-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Coming Soon
        </div>

        <h1 className="tool-title">College Search</h1>

        <p className="tool-message">
          Our college search tool is currently a work in progress. In the
          meantime, please visit the College Board's College Search page.
        </p>

        <div className="tool-links">
          <a
            href="https://bigfuture.collegeboard.org/college-search/filters"
            className="tool-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="tool-link-text">
              Go to College Board's College Search
              <svg
                className="tool-link-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </span>
          </a>

          <div className="tool-alternative">OR</div>

          <p className="tool-message">
            If you want to find out more about a specific university, you can
            visit the College Navigator website.
          </p>

          <a
            href="https://nces.ed.gov/collegenavigator/"
            className="tool-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="tool-link-text">
              Go to College Navigator
              <svg
                className="tool-link-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </span>
          </a>
        </div>

        <div className="tool-features">
          <h3 className="tool-features-title">What You'll Find</h3>
          <ul className="tool-features-list">
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Comprehensive college database with detailed information
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Advanced filtering by location, size, and programs
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Tuition costs, admission requirements, and statistics
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CollegeList;
